export const getEnvContextualizedCxEndpoint = () => {
  return `${typeof window !== 'undefined' ? window.location.origin : ''}/api/cx`;
};

export const getEnvContextualizedSportsCatalogueEndpoint = () => {
  return `${typeof window !== 'undefined' ? window.location.origin : ''}/api/cx/sports-catalogue`;
};
